import PropTypes from 'prop-types';

export const ModalFrameworkMethodsPropType = PropTypes.shape({
  cancelModal: PropTypes.func,
  closeModal: PropTypes.func,
});
